import Card from "../../components/Location/Card";
import ViewList from "../../components/Templates/ViewList";
import useLocationsContainer from "../../containers/Locations/useLocationsContainer";
import { useContent } from "../../content/useContent";
import { Routes } from "../../routes/Routes";
import { useParams } from "react-router-dom";

const Locations = () => {
  const { gameId } = useParams();

  const {
    locations,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage,
    handleOpenDelete,
    handleDelete,
    handleEdit,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  } = useLocationsContainer(gameId);

  const { locations: content } = useContent().pages;

  type IProps = {
    row: any;
  };

  const Row: React.FC<IProps> = ({ row }) => {
    return (
      <Card
        row={row}
        handleOpenDelete={handleOpenDelete}
        handleEdit={handleEdit}
      />
    );
  };

  return (
    <ViewList
      title={content.locations}
      multiTitle={content.multi}
      pageLoading={pageLoading}
      rowsPerPage={rowsPerPage}
      page={page}
      rows={locations}
      handleChangePage={handleChangePage}
      Row={Row}
      addPath={Routes.getAddLocation(gameId)}
      selected={selected}
      handleDelete={handleDelete}
      openDeleteDialog={openDeleteDialog}
      setOpenDeleteDialog={setOpenDeleteDialog}
      deleteLoading={loading}
    />
  );
};

export default Locations;
